<div class="overlay">
    <div class="spinner-container">
      <p-progressSpinner styleClass="w-6rem h-6rem" strokeWidth="4" animationDuration=".5s"></p-progressSpinner>
    </div>
</div>